import { render, staticRenderFns } from "./GetUploaded.vue?vue&type=template&id=3dbd0236"
import script from "./GetUploaded.vue?vue&type=script&lang=js"
export * from "./GetUploaded.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports